// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sqeb","left":"styles_left__1qgxd","desktopActions":"styles_desktopActions__3ASyj","title":"styles_title__2G0_B"};